module.exports = __webpack_public_path__ + "img/usuario-outlined.54972ec8.svg";